var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_666_5545",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_666_5545",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABbklEQVR4nO3ay0rDQBSA4erCC/joIkUErUIfwkVxF5hAYWadxTndCO694K3LkandFJp04fSMbf4Psmogh58wbScZDAAAAAAAAAAAAAAAAAAAWDWZzY5dkHMX9Ln2+ll7GU2nT6d0yh3Z66QOGlcOL6Oc1+m11shBowv6Xnq+vY+8vKPfSs+4/5EXofWi9Jx7Hzl9ns4rPevOaprmyHm577yTgz5U1eNJ6Vl3FpENENkAkQ0Q2QCRDRDZAJENENlA2tbc+LeaI3ZvO8ir83rVuUVcB70jpGa5mZyXm7WRY4yHLsg3oTVX6K/UdG3oOsic0Lrd0L9Lh9wSWvOEDnLdukanHTe+DPWvkV/qIJcbn5fy884QsQ0R2xCxDRHbELENEdsQsQ0R2xAv0Py/2EPLmXr8kqN+xBgPSs/Zg9gyb90qRNYX0cf03E7sYVouFg8QvIyrpjnLfR0spTWZdRkAAAAAAAAAAAAAAAAABgX8ACVFd31jSpO6AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.bc6dce9a88fd027d83244d120e2fc384.svg";
export { ForwardRef as ReactComponent };